// Side-effect import: bootstraps Amplify v6 before any provider mounts.
//
// ⚠️ MUST STAY FIRST. A provider that reads the session before Amplify is
// configured throws, and the failure looks like an auth bug rather than an
// ordering one.
import './init/amplify';
// CloudWatch RUM is off platform-wide until FNP-1120 decides it; the initialiser
// exists and reads config/cloudwatch-rum.ts, where every stage is disabled.
// import './init/cloudwatch-rum';

import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import {Provider as ReduxProvider} from 'react-redux';

import {App} from './App';
import {store} from './store';
import './index.css';

// FNP-1501: the provider tree lives in App.tsx, not here.
//
// It used to be split across both files, which is how the skeleton ended up
// with a hand-rolled QueryClient in main.tsx and no SessionGuardProvider
// anywhere — the two halves were never read together. Redux stays here because
// it wraps the app itself; everything session-shaped belongs next to the router
// it guards. The stylesheets are imported once, in App.tsx (checklist §3).
const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found in index.html');

createRoot(rootEl).render(
    <StrictMode>
        <ReduxProvider store={store}>
            <App/>
        </ReduxProvider>
    </StrictMode>,
);
